export default {
    company: {
        label: window.i18n.__('Société'),
        bgcolor: '--colors-component-background-information-tag-directory-company',
    },
    person: {
        label: window.i18n.__('Particulier'),
        bgcolor: '--colors-component-background-information-tag-directory-individual',
    },
    client: {
        label: window.i18n.__('Client'),
        bgcolor: '--colors-component-background-information-tag-directory-customer',
    },
    prospect: {
        label: window.i18n.__('Prospect'),
        bgcolor: '--colors-component-background-information-tag-directory-prospect',
    },
    supplier: {
        label: window.i18n.__('Fournisseur'),
        bgcolor: '--colors-component-background-information-tag-directory-supplier',
    },
    contact: {
        label: window.i18n.__('Contact'),
        bgcolor: '--colors-component-background-information-tag-directory-contact',
    },
    archived: {
        label: window.i18n.__('Archivé'),
        bgcolor: '--colors-component-background-information-tag-directory-archive',
    },
};
